import { useLanguage } from '@/shared/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from '@/i18n/i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/Select';
import { Label } from '@/shared/components/ui/Label';

const defaultLanguage = {
  value: 'en',
  label: 'English',
  flag: '🇺🇸',
} as const;

const languageOptions = [
  defaultLanguage,
  {
    value: 'he',
    label: 'עברית',
    flag: '🇮🇱',
  },
] as const;

export const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation('common');

  const selectedOption =
    languageOptions.find((opt) => opt.value === language) ?? defaultLanguage;

  return (
    <div className="space-y-2">
      <Label htmlFor="language-select">{t('language')}</Label>
      <Select
        value={language}
        onValueChange={(value: string) =>
          setLanguage(value as SupportedLanguages)
        }
      >
        <SelectTrigger id="language-select" className="h-12">
          <SelectValue>
            {selectedOption && (
              <div className="flex items-center gap-2">
                <span role="img" aria-label={`${selectedOption.label} flag`}>
                  {selectedOption.flag}
                </span>
                <span>{selectedOption.label}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="z-[99999]">
          {languageOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center gap-2">
                <span role="img" aria-label={`${option.label} flag`}>
                  {option.flag}
                </span>
                <span>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
